// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ck.ck-editor__editable_inline[dir=ltr][data-v-70f44cb2]{text-align:right!important;direction:rtl;border:1px solid #cbcbcb;background:#fff;min-height:300px}", ""]);
// Exports
module.exports = exports;
